import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import DropdownMenu from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { fg } from '@atlaskit/platform-feature-flags';
import { qualifiesForViralSettings } from '../../analytics';
import { useThirdPartyState } from '../ThirdParty';
import ThirdPartyMenuGroup from './ThirdPartyMenuGroup';
import AdminMenuGroup from './AdminMenuGroup';
import { useInvitePeopleContext } from '../InvitePeople';
import { messages } from '../i18n/messages';
import type { AdminMenuGroupComponentProps } from '../../types';

type MenuProps = AdminMenuGroupComponentProps;

export const Menu = ({ onAdminMenuItemClick }: MenuProps) => {
	const { formatMessage } = useIntl();
	const { userRole } = useInvitePeopleContext();
	// Enabled integrations are to show Connect To menu items
	// Connected integrations are to show Revoke menu items
	const { integrations: connectedIntegrations } = useThirdPartyState();
	const relevantIntegrationSize = connectedIntegrations.size;

	const thirdPartyMenuGroup = relevantIntegrationSize > 0 ? <ThirdPartyMenuGroup /> : null;
	const adminMenuGroup = qualifiesForViralSettings(userRole) ? (
		<AdminMenuGroup onAdminMenuItemClick={onAdminMenuItemClick} />
	) : null;

	if (!adminMenuGroup && !thirdPartyMenuGroup) {
		return null;
	}

	return (
		<div data-testid="testId-invite-people-dropdown-menu">
			<DropdownMenu
				placement="bottom-end"
				zIndex={560}
				trigger={({ triggerRef, ...providedProps }) => (
					<IconButton
						{...providedProps}
						ref={triggerRef}
						icon={MoreIcon}
						label={formatMessage(messages.formMoreActionsButtonLabel)}
						appearance="subtle"
					/>
				)}
				testId="testId-invite-people-dropdown-menu"
				shouldRenderToParent={fg('should-render-to-parent-should-be-true-growth-core')}
			>
				{thirdPartyMenuGroup}
				{adminMenuGroup}
			</DropdownMenu>
		</div>
	);
};

export default Menu;
